// extracted by mini-css-extract-plugin
module.exports = {"root":"Quantity_root__eI_vQ","input":"Quantity_input__Y3tzH","action":"Quantity_action__bCqMQ","inactive":"Quantity_inactive__F8fp5"};